// frontend/modules/auth/index.ts
import { ModuleConfig } from '../../core/module';
import { authRoutes } from './routes';
import { useAuthStore } from './stores/auth-store';

export const AuthModule: ModuleConfig = {
    name: 'auth',
    routes: authRoutes,
    stores: {
        auth: useAuthStore
    },
    initialize: () => {
        console.log('Auth module initialized');
    }
};

// Export auth utilities for use in other modules
export { ProtectedRoute } from './components/ProtectedRoute';
export { PermissionGate } from './components/PermissionGate';
export { BranchSwitcher } from './components/BranchSwitcher';
export { SessionInfo } from './components/SessionInfo';
export { useAuth } from './hooks/use-auth';
export { useHasPermission } from './hooks/use-has-permission';
export { useAuthStore } from './stores/auth-store';

